import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { backgroundImages } from '../realPhotosData';
import { Logo } from './Logo';

export const HeroSection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={backgroundImages.hero}
          alt="Technicien cordiste au travail"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo centré */}
          <div className="mb-8 flex justify-center">
            <Logo className="w-full max-w-2xl h-auto opacity-80 drop-shadow-[0_0_20px_rgba(255,255,255,0.3)]" />
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Experts en travaux
            <span className="block text-orange-500">acrobatiques</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8">
            Interventions en hauteur et accès difficiles sur toute l'Île-de-France
          </p>
          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
            Plus de 13 ans d'expérience au service de vos projets de bâtiment, maintenance et sécurisation. 
            Professionnalisme, rapidité et expertise garantis.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-8 py-6"
            >
              Demander un devis gratuit
            </Button>
            <Button
              onClick={scrollToServices}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black text-lg px-8 py-6"
            >
              Découvrir nos services
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="text-white" size={32} />
      </div>
    </section>
  );
};
